import { BaseError } from './base';

export class NoWebAuthNSupportError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_webauthn_support_error',
      docsUrl: null,
      name: 'NoWebAuthNSupportError',
      shortMessage: 'Browser does not support WebAuthn',
    });
  }
}
